import { Add } from '@mui/icons-material'

import { ListHeaderActions, ListHeaderPrimaryActionButton } from '@/components/List'

import { ReadOnlyTooltip } from '@/components/smartUtils/plan/ReadOnlyTooltip'
import { Tooltip } from '@/components/primitives/Tooltip'

import { useTexts } from '../../useTexts'
import { useActions } from './hooks/useActions'

export function Actions() {
  const { editing, onCreate } = useActions()
  const texts = useTexts()

  return (
    <ListHeaderActions>
      <ReadOnlyTooltip
        placement="bottom"
        render={preventEditing => (
          <Tooltip title={texts.addUser} placement="bottom">
            <ListHeaderPrimaryActionButton
              disabled={preventEditing || editing}
              onClick={onCreate}
              trackId="users__new-user"
            >
              <Add />
            </ListHeaderPrimaryActionButton>
          </Tooltip>
        )}
      />
    </ListHeaderActions>
  )
}
